import { render } from "./KOLMemberUpdate.vue?vue&type=template&id=19f5971c"
import script from "./KOLMemberUpdate.vue?vue&type=script&lang=js"
export * from "./KOLMemberUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__